import type { NextPage } from 'next';
import { Page as Component } from '~/components/specifics/vendors/settings/surveys/index/Page';
import { NskHead } from '~/components/common/head/NskHead';
import { useSessions } from '~/hooks/vendors/useSessions';
import { Page as Error403Component } from '~/containers/specifics/vendors/403/Page';

export const PATH = '/vendors/settings/surveys';

const SurveysSetting: NextPage = () => {
  const { data: session } = useSessions().index();
  if (session === null || !session.admin) {
    return <Error403Component />;
  }

  return (
    <>
      <NskHead title="アンケート設定" />
      <Component />
    </>
  );
};

export default SurveysSetting;
